module.exports = __webpack_public_path__ + "img/logo.c5e0e807.png";